import http from "@/utils/request";

//登录
export const userlogin=((data)=>{
    return http.post("/Admin/Admin/adminLogin",data)
})

//获取管理员列表
export const getAdminData=((params)=>{
    return http.get("/Admin/Admin/adminList",params)
})

//编辑管理员
export const editAdminData=((data)=>{
    return http.post("/Admin/Admin/adminAdd",data)
})

//删除管理员
export const deleteAdminData=((data)=>{
    return http.post("/Admin/Admin/adminDel",data)
})

//获取用户列表
export const getUserList=((params)=>{
    return http.post("/Admin/Admin/getUserList",params)
})
//商品分类列表
export const getClassList=((params)=>{
    return http.post("/Admin/Admin/getClassList",params)
})
//编辑商品分类
export const classAdd=((data)=>{
    return http.post("/Admin/Admin/classAdd",data)
})
//商品分类列表
export const saveClass=((params)=>{
    return http.post("/Admin/Admin/saveClass",params)
})

//删除商品分类
export const delClass=((data)=>{
    return http.post("/Admin/Admin/delClass",data)
})

//商品列表
export const getGoodsData=((params)=>{
    return http.post("/Admin/Admin/getShopList",params)
})

//编辑商品
export const editGoodsData=((data)=>{
    return http.post("/Admin/Admin/shopAdd",data)
})

//上下架商品
export const updateShopStatus=((data)=>{
    return http.post("/Admin/Admin/updateShopStatus",data)
})

//置顶商品
export const topSave=((data)=>{
    return http.post("/Admin/Admin/topSave",data)
})
//置顶分类商品
export const topCategorySave=((data)=>{
    return http.post("/Admin/Admin/topCategorySave",data)
})
//根据款号批量删除商品 
export const delShopList=((data)=>{
    return http.post("/Admin/Admin/delShopList",data)
})
//删除商品
export const deleteGoodsData=((data)=>{
    return http.post("/Admin/Admin/delShop",data)
})
//Banner列表
export const getBannerList=((data)=>{
    return http.post("/Admin/Admin/getBannerList",data)
})
//修改banner
export const saveBanner=((data)=>{
    return http.post("/Admin/Admin/saveBanner",data)
})

//Banner列表
export const getCustomerList=((data)=>{
    return http.post("/Admin/Admin/getCustomerList",data)
})
//修改banner
export const saveCustomer=((data)=>{
    return http.post("/Admin/Admin/saveCustomer",data)
})

//上传图片
export const uploadImg=((data)=>{
    return http.post("/Admin/Admin/uploadImage",data)
})